import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import classes from "./styles.module.scss";
import { CollapsibleSectionItem } from "@/ui";

export default function CollapsibleSection({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  description,
  items,
  collapse_all,
  defaultActiveKey = 0,
  md = 8,
}) {
  const [openStates, setOpenStates] = useState(
  items.map((item, idx) => {
    if (collapse_all) return false; // start all closed if collapse_all
    return typeof item.open === "boolean" ? item.open : false;
  })
);


const toggleItem = (index) => {
  setOpenStates((prev) =>
    prev.map((isOpen, i) =>
      i === index ? !isOpen : isOpen
    )
  );
};

  // if collapse becomes true → close everything
  // useEffect(() => {
  //   if (collapse_all) {
  //     setOpenStates(items.map(() => false));
  //   }
  // }, [collapse_all, items]);

  if (items.length === 0) return null;

  return (
    <div
      id={sectionId}
      className={clsx(className, bgColor, classes.collapsible)}
    >
      <Container>
        {title && (
          <>
            <h2 className={titleColor}>{title}</h2>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </>
        )}
        <Row>
          <Col xs={12} md={md}>
            {items.map(({ title, body }, k) => (
              <CollapsibleSectionItem
                key={k}
                title={title}
                body={body}
                active={openStates[k]}
                onClick={() => toggleItem(k)}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
